import { render, staticRenderFns } from "./alarmDALI.vue?vue&type=template&id=85198bc4&scoped=true"
import script from "./alarmDALI.vue?vue&type=script&lang=js"
export * from "./alarmDALI.vue?vue&type=script&lang=js"
import style0 from "./alarmDALI.vue?vue&type=style&index=0&id=85198bc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85198bc4",
  null
  
)

export default component.exports